mutation UpdateStreamingSettings($input: UpdateStreamingSettingsInput!) {
  updateStreamingSettings(input: $input) {
    id
    streamingSettings {
      accountId
      apiTokenMask
      connectedAt
    }
  }
}
